
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div is="slide-control" class="image-gallery__slide-control ' +
((__t = ( context.className )) == null ? '' : __t) +
'"><div class="slide-control ';
 if (context.offsetDisplay === true) { ;
__p += 'slide-control--offset';
 } ;
__p += '"><div class="slide-control__slides" data-slide-strip>';
 _.times(context.totalDisplayedSlides, function() { ;
__p += '<div class="slide-control__slide needsclick" data-slide ';
 if (context.zoomEnabled) { ;
__p += 'is="zoomable-element"';
 } ;
__p += '></div>';
 }) ;
__p += '</div></div></div>';
return __p
};
    